import { gql } from '@apollo/client';

export const GET_INDICATOR_MODE_VIEWS = gql`
  query GetIndicatorModelViews($input: IndicatorModelViewInput) {
    indicatorModelViews: getIndicatorModelViews(input: $input) {
      OrganisationID
      Organisation
      OrganisationType
      ProgrammeOrInterventionID
      ProgrammeOrInterventionName
      Type
      ParentID
      Parent
      Owner
      StartDate
      EndDate
      Objective
      Indicator
      Unit
      Frequency
      Category1
      Category2
      Category3
      ReporterID
      Reporter
      Dimension1
      Dimension1Option
      Dimension2
      Dimension2Option
      Dimension3
      Dimension3Option
      Period
      PeriodDate
      Target
      Actual
      Benchmark1Type
      Benchmark1
      Benchmark2Type
      Benchmark2
      Benchmark3Type
      Benchmark3
      DueDate
      SubmissionDate
      SubmissionStatus
    }
  }
`;
